function loadOneTrustCookie() {
  const cookieConsentScript = document.createElement("script");
  cookieConsentScript.type = "text/javascript";
  cookieConsentScript.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
  cookieConsentScript.charset = "UTF-8";
  cookieConsentScript.setAttribute("data-document-language", "true");
  cookieConsentScript.setAttribute("data-domain-script", `${process.env.REACT_APP_DATA_DOMAIN_SCRIPT}`);
  cookieConsentScript.setAttribute("async", "true");
  cookieConsentScript.setAttribute("defer", "true");
  cookieConsentScript.setAttribute("fetchpriority", "low");
  document.head.appendChild(cookieConsentScript);
}

function loadGTM() {
  // window.dataLayer = []; // causes a bug, where previous dataLayer array from index.html loses it's fired events
  const script = document.createElement("script");
  script.setAttribute("async", "true");
  script.setAttribute("defer", "true");
  script.setAttribute("fetchpriority", "low");
  script.textContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${process.env.REACT_APP_GOOGLE_GTM_ID}');`;
  document.body.appendChild(script);
}

// function loadGoogleRecaptcha() {
//   if (window.grecaptcha) return null;
//   const script = document.createElement("script");
//   script.setAttribute("async", "true");
//   script.setAttribute("defer", "true");
//   script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_GOOGLE_RECAPTCHA_V3}`;
//   document.body.appendChild(script);
// }

const intervalKey = setInterval(fetchThirdPartyResources, 500);
function fetchThirdPartyResources() {
  const isLoader = document.body.querySelector("#page_loader");
  const isReactDOMHydrated = document.body.querySelector("#root")?.childNodes.length > 0;
  if (document.readyState === "complete" && !isLoader && isReactDOMHydrated) {
    try {
      loadOneTrustCookie();
      loadGTM();
      // loadGoogleRecaptcha(); // being called twice
    } catch (err) {
      console.error("error fetching onetrust/GTM scripts: ", err);
    } finally {
      clearInterval(intervalKey);
    }
  }
}

export {};
